<template>
  <v-container>
    <v-row v-if="departures.length == 0">
      <add-btn
        label="Add Departures"
        icon="mdi-calendar"
        @click="onAddDeparture"
      ></add-btn>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-container fluid py-0>
          <v-row justify="end">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="ml-2"
                  fab
                  dark
                  color="primary"
                  @click="onAddDeparture"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
              Add Departure
            </v-tooltip>
          </v-row>
        </v-container>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-data-table :headers="headers" :items="departures">
                <template v-slot:item.validFrom="{ item }">{{
                  item.validFrom | formatDate
                }}</template>
                <template v-slot:item.validTo="{ item }">{{
                  item.validTo | formatDate
                }}</template>
                <template v-slot:item.daysOfWeek="{ item }">
                  {{ daysLabeler(item.daysOfWeek) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <default-list-actions
                    :item="item"
                    @deleteItem="onDelete"
                    @editItem="onEdit"
                    hide-view
                  ></default-list-actions>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ value }}{{ departures }}</code>
      </v-col>
    </v-row>
    <template-departure-dialog
      v-model="editedDeparture"
      :show="showTemplateDepartureDialog"
      @close="showTemplateDepartureDialog = false"
      @save="onSave"
    ></template-departure-dialog>
  </v-container>
</template>

<script>
import AddBtn from "../../shared/AddBtn";
import TemplateDepartureDialog from "./TemplateDepartureDialog";
import DefaultListActions from "../../shared/DefaultListActions";
import { TEMPLATE_RECORD_QUERY } from "../../../../constants/graphql";
import gql from "graphql-tag";

const CREATE_DEPARTURE_MUTATION = gql`
  mutation createTemplateDeparture(
    $templateId: ID!
    $input: TemplateDepartureInput!
  ) {
    createTemplateDeparture(templateId: $templateId, departure: $input) {
      id
      daysOfWeek
      validFrom
      validTo
    }
  }
`;
const DELETE_DEPARTURE_MUTATION = gql`
  mutation deleteTemplateDeparture($id: ID!) {
    deleteTemplateDeparture(id: $id) {
      id
      daysOfWeek
      validFrom
      validTo
    }
  }
`;
const UPDATE_DEPARTURE_MUTATION = gql`
  mutation updateTemplateDeparture($id: ID!, $input: TemplateDepartureInput) {
    updateTemplateDeparture(id: $id, departureInput: $input) {
      id
      daysOfWeek
      validFrom
      validTo
    }
  }
`;
export default {
  name: "template-departure-dates",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    templateId: {
      type: String,
      defualt: () => "",
    },
  },

  components: {
    AddBtn,
    TemplateDepartureDialog,
    DefaultListActions,
  },

  data() {
    return {
      debug: false,
      departures: this.value && this.value.length > 0 ? [...this.value] : [],
      showTemplateDepartureDialog: false,
      editedDeparture: {},
      newDeparture: {},
      headers: [
        {
          text: "Valid From",
          value: "validFrom",
          name: "validFrom",
        },
        {
          text: "Valid To",
          value: "validTo",
          name: "validTo",
        },
        {
          text: "Days of Week",
          value: "daysOfWeek",
          name: "daysOfWeek",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  watch: {
    value(newVal) {
      this.departures = [...newVal];
    },
  },

  methods: {
    daysLabeler(daysOfWeek) {
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      return daysOfWeek
        .split(",")
        .map((d) => days[d])
        .join(",");
    },
    onAddDeparture() {
      this.editedDeparture = { ...this.newDeparture };
      this.showTemplateDepartureDialog = true;
    },
    onEdit(payload) {
      this.editedDeparture = { ...payload };
      this.showTemplateDepartureDialog = true;
    },
    onSave(payload) {
      this.showTemplateDepartureDialog = false;
      const { id, ...input } = payload;
      const mutation = payload.id
        ? UPDATE_DEPARTURE_MUTATION
        : CREATE_DEPARTURE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: { input, templateId: this.templateId, id },
          refetchQueries: [
            {
              query: TEMPLATE_RECORD_QUERY,
              variables: { id: this.templateId },
            },
          ],
        })
        .then((res) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Departure Saved.",
          });
        })
        .catch((err) => console.log("save error", err));
    },
    onDelete(payload) {
      this.$apollo
        .mutate({
          mutation: DELETE_DEPARTURE_MUTATION,
          variables: { id: payload.id },
          refetchQueries: [
            {
              query: TEMPLATE_RECORD_QUERY,
              variables: { id: this.templateId },
            },
          ],
        })
        .then((res) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Departure Removed.",
          });
        })
        .catch((err) => console.log("save error", err));
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/templates/builder/TemplateDepartureDates.vue